import React from 'react'
import styles from './Header.module.css'
import Cart from '../Cart/Cart'
import { useCart } from '../../../contexts/CartContext'
import { Link, NavLink } from 'react-router-dom'

const Header = () => {
  const cart = useCart()

  const handleOpenCart = () => {
    cart.setIsVisibleCart(true)
  }
  return (
    <div className={styles.header}>
      <Link to="/" className={styles.logoTitle}>
        Алкомиг 77
      </Link>
      <div className={styles.row}>
        <NavLink to="/contacts">Контакты</NavLink>
        <button className={styles['cart-button']} onClick={handleOpenCart}>
          <img src="/icons/cart.svg" alt="" />
          {cart.cartProducts.length > 0 ? <span className={styles.quantity}>{cart.cartProducts.length}</span> : null}
        </button>
      </div>
      <Cart />
    </div>
  )
}

export default Header
